// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"d9b3ae70","488":"2bbdc5ec"}[chunkId] + ".chunk.js";
};